const clampCoordinate = value => Math.min(1, Math.max(0, value));

export const normalizeAnnotationPoints = (points = []) => {
  if (!Array.isArray(points)) return [];

  return points.flatMap(point => {
    const x = Number(Array.isArray(point) ? point[0] : point?.x);
    const y = Number(Array.isArray(point) ? point[1] : point?.y);
    if (!Number.isFinite(x) || !Number.isFinite(y)) return [];

    return [{
      x: Number(clampCoordinate(x).toFixed(6)),
      y: Number(clampCoordinate(y).toFixed(6)),
    }];
  });
};

export const indexImageAnnotations = (annotations = []) => {
  if (!annotations) return {};

  const entries = Array.isArray(annotations)
    ? annotations.map(annotation => [
        annotation?.image_id ?? annotation?.imageId ?? annotation?.id,
        annotation?.points ?? annotation?.annotation_points ?? [],
      ])
    : Object.entries(annotations);

  return Object.fromEntries(entries.flatMap(([imageId, points]) => {
    if (imageId === null || imageId === undefined || imageId === '') return [];
    const normalizedPoints = normalizeAnnotationPoints(points);
    return normalizedPoints.length ? [[String(imageId), normalizedPoints]] : [];
  }));
};

export const serializeImageAnnotations = annotationsByImage => Object.entries(annotationsByImage || {})
  .flatMap(([imageId, points]) => {
    const normalizedPoints = normalizeAnnotationPoints(points);
    if (!normalizedPoints.length) return [];

    const numericImageId = Number(imageId);
    return [{
      image_id: Number.isFinite(numericImageId) ? numericImageId : imageId,
      points: normalizedPoints,
    }];
  });
